import React, { useEffect } from "react"

import { useRecoilValue } from "recoil"
import { isManagerSelector, userAtom } from "@/atoms/userAtom"
import { useTranslation } from "react-i18next"
import SettingSection from "../../shared/SettingSection"
import SettingContentWrapper from "../../shared/SettingContentWrapper"
import { Loader } from "@/UI"
import { isEmpty } from "lodash"
import ZonesTable from "./components/ZonesTable"
import { useZones } from "@/hooks/useZones"
import ImportZoneModal from "./components/ImportZoneModal"

interface IStoresSettingsProps {}

const ZonesSettings: React.FC<IStoresSettingsProps> = () => {
  const { t } = useTranslation()
  const { zones, isLoading, fetchZones } = useZones()
  const { org } = useRecoilValue(userAtom)
  const isManager = useRecoilValue(isManagerSelector)

  useEffect(() => {
    fetchZones()
  }, [org?.id])

  if (isLoading) {
    return (
      <SettingSection title={t("common.zones")}>
        <div className="absolute" style={{ top: "45%", left: "55%" }}>
          <Loader fontSize={48} />
        </div>
      </SettingSection>
    )
  }

  return (
    <SettingSection
      title={t("common.zones")}
      actionButton={
        !isManager && (
          <div className="flex justify-between items-center mb-2">
            <a
              href="https://www.kosmo.delivery/en/blog/create-your-zones"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 underline hover:text-blue-700 mr-4"
            >
              {t("common.zones.viewGuide")}
            </a>
            {!isManager && <ImportZoneModal isDisabled={false} />}
          </div>
        )
      }
    >
      {isEmpty(zones) ? (
        <SettingContentWrapper>
          <div className="flex flex-col items-center gap-y-4">
            <p className="font-bold">{t("profile.ZonesSettings.createYourFirstZone")}</p>
            {!isManager && <ImportZoneModal isDisabled={false} />}
          </div>
        </SettingContentWrapper>
      ) : (
        <div className="flex flex-col w-full gap-y-4">
          <ZonesTable zones={zones} />
        </div>
      )}
    </SettingSection>
  )
}

export default ZonesSettings
